import { NavigationDocument } from '@barthauer/abc/arena';
import { CacheContext, QueryObjectsModel } from '@barthauer/abc/core/data';

export class ArenaCacheSettings {
  modifyNavigationDocument: (navDoc: NavigationDocument) => Promise<void>;
  applyExtentFilter: (query: QueryObjectsModel, ctx: CacheContext) => Promise<QueryObjectsModel>;

  constructor() {}
}
